export const ENCRYPT_DECRYPT_KEY = process.env.REACT_APP_ENCRYPT_REQUEST_KEY;
